import {
  AutoAwesomeRounded,
  FormatQuoteRounded,
  NumbersRounded,
} from '@mui/icons-material';
import {
  AutocompleteRenderGroupParams,
  Box,
  Paper,
  Stack,
  Typography,
} from '@mui/material';
import { memo } from 'react';

interface AutoCompleteGroupProps {
  params: AutocompleteRenderGroupParams;
}

export const AutoCompleteGroup = memo(function AutoCompleteGroup({
  params,
}: AutoCompleteGroupProps) {
  const getIcon = () => {
    switch (params.group) {
      case 'Suggested':
        return <AutoAwesomeRounded fontSize="small" />;
      case 'All Reasons':
        return <FormatQuoteRounded fontSize="small" color="disabled" />;
      case 'All Tracked Keywords':
        return <NumbersRounded fontSize="small" color="disabled" />;
      default:
        return null;
    }
  };

  return (
    <Box component="li" key={params.key}>
      {params.group && (
        <Paper elevation={0} sx={{ pr: 2, py: 1.5, borderRadius: 0 }}>
          <Stack
            direction="row"
            spacing={1}
            py={0.5}
            px={1}
            alignItems="center"
          >
            {getIcon()}
            <Typography variant="body2" color="text.secondary">
              {params.group}
            </Typography>
          </Stack>
        </Paper>
      )}
      <Stack>{params.children}</Stack>
    </Box>
  );
});
